import React from "react";
import PropTypes from "prop-types";
import { Body as ModalBody } from "MODULES/shared/components/Modal";

// TBD
const CANCELLATION_REASONS = [
  { value: "previously_sold", text: "Previously Sold" },
  { value: "part_deemed_ber", text: "Part Deemed B.E.R" },
  { value: "vendor_cant_find", text: "Vendor Can't Find" },
  { value: "unethical_behavior_detected", text: "Unethical Behavior Detected" },
  { value: "cancelled_by_tenant", text: "Cancelled by Us" },
  { value: "unknown", text: "Unknown" }
];

export default function Body({
  reason = CANCELLATION_REASONS[0],
  updateReason
}) {
  return (
    <ModalBody>
      <div>
        <div className="center-block alert alert-warning">
          <div className="media">
            <div className="media-left">
              <i className="fa fa-lg fa-warning text-warning" />
            </div>
            <div className="media-body">
              Removing this item will permanently remove it from the repair
              order and return the inventory to the Reserved for Repair list.
            </div>
          </div>
        </div>
        <label className="control-label" htmlFor="cancellation_reason">
          Cancellation Reason
        </label>
        <select
          className="form-control"
          name="cancellation_reason"
          onChange={e => updateReason(e.target.value)}
          value={reason}
        >
          {CANCELLATION_REASONS.map(r => (
            <option key={r.value} value={r.value}>
              {r.text}
            </option>
          ))}
        </select>
      </div>
    </ModalBody>
  );
}

Body.propTypes = {
  reason: PropTypes.string.isRequired,
  updateReason: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/Cancel/Body.jsx